import { ServiceStatus } from '../types';

export const getRibbonText = (
  productRibbon: string,
  serviceStatus?: ServiceStatus
): string => {
  const isActiveService = [
    ServiceStatus.Activated,
    ServiceStatus.Purchased,
    ServiceStatus.TestingCompleted,
  ].includes(serviceStatus ?? ServiceStatus.NotActivated);

  if (isActiveService) {
    return 'Your Current Plan';
  }

  return productRibbon;
};
